import LOHPDesktopSlide1 from 'images/front-page/LOHPDesktopSlide1.png';
import LOHPDesktopSlide2 from 'images/front-page/LOHPDesktopSlide2.png';
import LOHPDesktopSlide3 from 'images/front-page/LOHPDesktopSlide3.png';
import LOHPMobileCard1 from 'images/front-page/LOHPMobileCard1.png';
import LOHPMobileCard2 from 'images/front-page/LOHPMobileCard2.png';
import LOHPMobileCard3 from 'images/front-page/LOHPMobileCard3.png';

import _t from 'i18n!nls/front-page';

export const getMockDesktopHeroSlideData = () => [
  {
    content: {
      visual: {
        url: LOHPDesktopSlide1,
      },
      title: _t('Get job ready with new AI skills'),
      description: _t(
        'Stand out to employers with an industry-leading Professional Certificate and must-have AI skills from Google, IBM, Meta, Microsoft, and more.'
      ),
      callToActionLabel: _t('Browse certificates'),
      callToActionLink: '/explore/generative-ai',
    },
    secondaryButtonLabel: _t('Join for free'),
    secondaryButtonLink: '/?authMode=signup',
    slideTrackingName: 'lohp_desktop_hero_slide_1',
  },
  {
    content: {
      visual: {
        url: LOHPDesktopSlide3,
      },
      title: _t('Advance your learning with Coursera Coach'),
      description: _t(
        'Get on-demand, AI-powered guidance that’s tailored to your unique goals and leverages expert content on Coursera.'
      ),
      callToActionLabel: _t('Subscribe to try Coach'),
      callToActionLink: '/explore/coach',
    },
    secondaryButtonLabel: _t('Join Coursera for free'),
    secondaryButtonLink: '/?authMode=signup',
    slideTrackingName: 'lohp_desktop_hero_slide_2',
  },
  {
    content: {
      visual: {
        url: LOHPDesktopSlide2,
      },
      title: _t('Upskill your teams with GenAI Academy'),
      description: _t(
        'Equip teams to understand and ethically adopt GenAI best practices unique to their business function, unlocking innovation and productivity.'
      ),
      callToActionLabel: _t('Unlock GenAI Academy'),
      callToActionLink:
        '/business/generative-ai-academy?utm_campaign=website&utm_content=banner-from-B2C-home-try-business&utm_medium=coursera&utm_source=enterprise',
    },
    slideTrackingName: 'lohp_desktop_hero_slide_3',
    backgroundPosition: 'bottom right / cover',
  },
];

export const getMockMobileHeroCardData = () => [
  {
    title: _t('Get job ready with new AI skills'),
    subtitle: _t('Stand out with a Professional Certificate'),
    primaryCtaLabel: _t('Browse certificates'),
    primaryCtaLink: '/explore/generative-ai',
    secondaryCtaLabel: _t('Join for free'),
    secondaryCtaLink: '/?authMode=signup',
    image: LOHPMobileCard1,
    backgroundColor: 'white',
  },
  {
    title: _t('Advance your learning with Coursera Coach'),
    subtitle: _t('Get on-demand, AI-powered guidance'),
    primaryCtaLabel: _t('Subscribe to try Coach'),
    primaryCtaLink: '/explore/coach',
    secondaryCtaLabel: _t('Join Coursera for free'),
    secondaryCtaLink: '/?authMode=signup',
    image: LOHPMobileCard3,
    backgroundColor: 'white',
  },
  {
    title: _t('Upskill your teams with GenAI Academy'),
    subtitle: _t('Equip teams to understand GenAI best practices'),
    primaryCtaLabel: _t('Unlock GenAI Academy'),
    primaryCtaLink:
      '/business/generative-ai-academy?utm_campaign=website&utm_content=banner-from-B2C-home-try-business&utm_medium=coursera&utm_source=enterprise',
    image: LOHPMobileCard2,
    backgroundColor: 'white',
  },
];
